import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { DomUtil } from "../../util/DomUtil";
import {
    ITopicAlertLoadRequest
} from "../../models/TopicAlert/ITopicAlertLoadRequest";
import {
    ITopicAlertRegisterRequest
} from "../../models/TopicAlert/ITopicAlertRegisterRequest";
import {
    ITopicAlertSaveRequest
} from "../../models/TopicAlert/ITopicAlertSaveRequest";
import { PageContext } from "../../service/PageContext";
import { StringUtil } from "../../util/StringUtil";
import { UiUtil } from "../../util/UiUtil";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import { HealioErrorModal } from "../healioGlobal/HealioErrorModal";

export class HealioMinuteSignUp extends Component {
    private readonly healioMinuteSubscribedKey = "_healio_minute_sub"
    private readonly emailInput: HTMLInputElement;
    private readonly invalidClass = "is-invalid";
    private readonly modal: HTMLElement;
    private readonly subscribeButton: HTMLButtonElement;
    private readonly subscribeSpans: HTMLSpanElement[];
    private readonly subscribedSpans: HTMLSpanElement[];
    private _isSubscribed: boolean = false;
    private _listId: string | undefined = undefined;
    private _modalId: string | undefined = undefined;
    private _settingsId: string | undefined = undefined;


    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this._modalId = this._element.dataset.modalId ?? ""
        this._listId = this._element.dataset.listId;
        this._settingsId = this._element.dataset.settingsId;
        this.modal = DomUtil.query(this._element, `[data-modal=${this._modalId}]`)
        document.body.appendChild(this.modal);
        this.subscribeButton = DomUtil.query(this.modal, "[data-action='Healio Minute Subscribe']");
        this.emailInput = DomUtil.query(this.modal, "[data-input='Healio Minute Email']");
        this.subscribeSpans = DomUtil.queryAll(this._element, "[data-view=subscribe]")
        this.subscribedSpans = DomUtil.queryAll(this._element, "[data-view=subscribed]")
    }

    public async init(): Promise<void> {
        const context = this._pageContext;
        const service = context ? context.topicAlertService : null;
        this.subscribeButton.addEventListener("click", ev => this.handleSubscribe(ev));
        this.emailInput.addEventListener("input", ev => this.handleEmailChanged(ev));

        const profile = await WyanokeUtil.loadUserProfile(true, false);
        const userHasSubscribed = sessionStorage.getItem(this.healioMinuteSubscribedKey)
        if (userHasSubscribed) {
            if ((!profile?.contactid && userHasSubscribed === "00000000-0000-0000-0000-000000000000") ||
            (profile?.contactid && profile.contactid === userHasSubscribed)){
            this._isSubscribed = true;
            this.handleAlreadySubscribed();
            return;
            }
        }
        if (profile && profile.isLoggedIn === "True"
            && profile.contactid
            && !this._isSubscribed) {

            const emailInputParent = this.emailInput.parentNode as HTMLElement;
            emailInputParent?.classList.add("d-none")
            this.subscribeButton.removeAttribute("disabled")


            const topicAlertLoadRequest: ITopicAlertLoadRequest = {
                contactid: window.UserProfile.contactid || "00000000-0000-0000-0000-000000000000",
                newswirefilters: [
                    {
                        Key: "CRM Guid",
                        Value: this._listId || ""
                    }
                ],
                sectionfilters: [],
                startitemid: this._settingsId || ""
            };

            const topicResponse =
                await service?.getTopicAlertWithStatus(topicAlertLoadRequest);

            if (!topicResponse) {
                return;
            }

            this._isSubscribed =
                topicResponse.Subscribed === "1";
        }
        if (this._isSubscribed) {
            sessionStorage.setItem(this.healioMinuteSubscribedKey, window.UserProfile.contactid || "00000000-0000-0000-0000-000000000000");
            this.handleAlreadySubscribed();
            return
        } else {
            this.subscribeSpans.forEach(span => span.classList.remove("d-none"))
            $(this.modal).on("hidden.bs.modal", () => {
                if ($(`.show[data-modal=${this._modalId}]`).length) {
                    $(`.show[data-modal=${this._modalId}]`).modal("hide");
                    $('.modal-backdrop:visible').remove();
                }
            })
        }
    }

    private handleEmailChanged(ev: Event): void {
        const emailField = ev.target as HTMLInputElement;
        if (StringUtil.isValidEmail(emailField.value)) {
            this.subscribeButton.removeAttribute("disabled")
            return
        }
        this.subscribeButton.setAttribute("disabled", "")
        return
    }

    private handleError(): void {
        UiUtil.toggleButtonState(this.subscribeButton);
        this.subscribedSpans.forEach(span => span.classList.add("d-none"))
        this.subscribeSpans.forEach(span => span.classList.remove("d-none"))
        window.dispatchEvent(new Event(HealioErrorModal.HealioErrorEvent));
    }

    private handleSuccess(): void {
        UiUtil.toggleButtonState(this.subscribeButton);
        $(this.modal).modal("hide");
        $('.modal-backdrop').remove();
        this.subscribeSpans.forEach(span => span.classList.add("d-none"))
        this.subscribedSpans.forEach(span => span.classList.remove("d-none"))
    }

    private handleAlreadySubscribed(): void {
        this.subscribeSpans.forEach(span => span.classList.add("d-none"))
        this.subscribedSpans.forEach(span => span.classList.add("d-none"))
    }


    private async handleSubscribe(ev: Event): Promise<void> {
        const context = this._pageContext;
        const service = context ? context.topicAlertService : null;
        if (!window.UserProfile || !service || !this._listId) {
            console.warn("Unable to subscribe to Topic Alert. ListId, Service, or UserProfile not found");

            return;
        }

        // Known Users
        if (window.UserProfile.isLoggedIn === "True"
            && window.UserProfile.contactid) {
            UiUtil.toggleButtonState(this.subscribeButton);
            const topicAlertSaveRequest: ITopicAlertSaveRequest = {
                contactid: window.UserProfile.contactid,
                listid: this._listId,
                status: "2",
            };
            const savedTopic = await service.save(topicAlertSaveRequest);
            if (savedTopic && savedTopic === "True") {
                console.log("Healio Minute Subscribed")
                this.handleSuccess();

                return;
            }
            this.handleError();

            return;

        }
        // Non users that need to provide email
        if (!this.emailInput) {
            console.warn("MISSING EMAIL INPUT FOR HealioMinute SIGN UP");

            return;
        }

        this.emailInput.classList.remove(this.invalidClass);
        if (!StringUtil.isValidEmail(this.emailInput.value)) {
            this.emailInput.classList.add(this.invalidClass);

            return;
        }

        const crmHidden = DomUtil.query(this._element, "[data-crm-source]", false);
        if (!crmHidden || !crmHidden.dataset.crmSource) {
            console.warn("MISSING CRM SOURCE FOR HEALIOMINUTE REGISTRATION");

            return;
        }

        UiUtil.toggleButtonState(this.subscribeButton);
        const topicAlertRegisterRequest: ITopicAlertRegisterRequest = {
            email: this.emailInput.value,
            listid: this._listId,
            source: crmHidden.dataset.crmSource,
        };

        const registerResponse =
            await service.register(topicAlertRegisterRequest);
        if (registerResponse && registerResponse !== undefined &&
            (registerResponse?.toLowerCase().indexOf("true") > -1 ||
                registerResponse?.toLowerCase().indexOf("existing") > -1)) {
            this.handleSuccess();
            sessionStorage.setItem(this.healioMinuteSubscribedKey, window.UserProfile.contactid || "00000000-0000-0000-0000-000000000000")

            return;
        }

        this.handleError();

    }
}
ComponentFactory.registerComponent("HealioMinuteSignUp", HealioMinuteSignUp);
